import type { OmitByValue } from '../type';

/**
 * 去掉对象中的空值 null undefined '' 后返回，注意 false 不会清理
 *
 * @param obj 要处理的对象
 * @example
 * ```typescript
 * const obj = {
 *   a: 1,
 *   b: 'str',
 *   c: null,
 *   d: undefined,
 *   f: false,
 *   e: {},
 *   g: [],
 * };
 *
 * const newObj = shakeObj(obj);
 * // expected result:  { a: 1, b: 'str', e: {}, f: false, g: [] }
 * ```
 */
export const shakeObj = <T extends { [K in keyof T]: unknown }>(
  obj: T,
): OmitByValue<T, null | undefined | ''> => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  return Object.entries(obj).reduce((pre, [key, value]) => {
    // 为空
    if (value === undefined || value === null || value === '') {
      return pre;
    }

    // 其他
    return { ...pre, [key]: value };
  }, Object.create({}));
};
